<template>
    <v-text-field
            :id="name" :name="name" :label="label" :hint="hint"
            v-model="value"
            class="numberField" :hide-details="hint?false:true" :persistent-hint="hint?true:false"
            outlined
            v-on:change="$emit('input', value)"
    >
        <template slot="append" style="margin-top:-7px">
            <v-btn right depressed text @click="minusValue"><div class="adjustNumberBtn"><span class="material-icons">remove</span></div></v-btn>
            <v-btn right depressed text @click="plusValue"><div class="adjustNumberBtn"><span class="material-icons">add</span></div></v-btn>
        </template>
    </v-text-field>
</template>

<script>
export default {
  name: 'NumberField',
  props: {
    name: {
      type: String
    },
    label: {
      type: String
    },
    max: {
      type: Number
    },
    hint: {
      type: String
    },
    increment: {
      type: Number,
      default: 1
    }
  },
  data: function () {
    return {
      value: 0
    }
  },
  watch: {
    value: function () {
      this.$emit('input', this.value)
    }
  },
  methods: {
    minusValue () {
      if (this.value > 0) this.value = this.value - this.increment
      return false
    },
    plusValue () {
      if (!this.value) this.value = this.increment
      else if (this.value < this.max) this.value = this.value + this.increment
      return false
    }
  }
}
</script>

<style lang="scss">
    @import '../styles/variables';
    @import '../../node_modules/vuetify/dist/vuetify.min.css';

    .numberField {
        &.v-text-field--enclosed {
            .v-input__append-inner {
                margin-top: 4px;
                margin-right: -13px;
            }

            .v-btn {
                margin-top: -2px;
                height: 54px;
                -webkit-border-radius: 0;
                -moz-border-radius: 0;
                border-radius: 0;
                border-left: 1px solid #DDDFE8;

                .adjustNumberBtn {
                    position: relative;
                    padding: 0 !important;
                    span {
                      color: $growth-3;
                    }

                    &:before,
                    &:after {
                        content: "";
                        position: absolute;
                        background-color: #DDDFE8;
                    }

                }
            }
        }
        .v-messages__message {
            margin-left: -10px;
            font-size: 1.4em;
            color: $core;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/NumberField.vue